import { motion } from 'framer-motion';

const AboutMission = () => {
  const sections = [
    {
      title: 'Nuestra Misión',
      content: 'Bala Corp nace con la misión de democratizar el acceso a servicios legales de calidad en Chile. Creemos que emprendedores, pymes y empresas merecen soluciones jurídicas rápidas, claras y accesibles sin sacrificar profesionalismo. Combinamos herramientas tecnológicas con la experiencia de abogados certificados para entregar documentos legales y gestionar trámites de forma eficiente.',
      image: 'https://public.readdy.ai/ai/img_res/880327bb8b3058be5a80c482d418f89b.jpg',
    },
    {
      title: 'Tecnología e Innovación',
      content: 'En Bala Corp utilizamos tecnología de punta para optimizar procesos legales tradicionales que solían tomar semanas. Nuestros procesos estructurados y herramientas tecnológicas agilizan la redacción y revisión de documentos legales con precisión, mientras que nuestro equipo de abogados profesionales garantiza que cada entrega cumpla con los más altos estándares de calidad jurídica. Esta combinación nos permite ofrecer servicios rápidos sin comprometer la excelencia.',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20artificial%20intelligence%20technology%20interface%20for%20legal%20services%2C%20modern%20digital%20workspace%20with%20yellow%20highlights%2C%20advanced%20technology%20visualization%2C%20professional%20corporate%20environment&width=600&height=400&seq=about-tech-001&orientation=landscape',
    },
    {
      title: 'Nuestra Visión',
      content: 'Aspiramos a convertirnos en la plataforma legaltech líder de Chile, siendo el primer recurso al que emprendedores y empresas acuden para resolver sus necesidades legales. Queremos construir un ecosistema donde la tecnología y el derecho trabajen en armonía para hacer que los servicios jurídicos sean accesibles, comprensibles y eficientes para todos. Nuestro objetivo es que ninguna empresa deje de crecer por falta de acceso a asesoría legal de calidad.',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20vision%20of%20legal%20technology%20in%20Chile%2C%20modern%20cityscape%20with%20digital%20elements%2C%20yellow%20and%20black%20color%20scheme%2C%20innovation%20and%20growth%20concept%2C%20professional%20business%20future&width=600&height=400&seq=about-vision-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-24">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'bg-gray-light rounded-3xl p-8 lg:p-12' : ''
              }`}
            >
              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
                  {section.title}
                </h2>
                <p className="text-lg text-gray-dark leading-relaxed">
                  {section.content}
                </p>
              </div>

              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                  className="relative rounded-3xl overflow-hidden shadow-2xl"
                >
                  <img
                    src={section.image}
                    alt={section.title}
                    className="w-full h-auto object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutMission;